import { getNumberOfDays } from '../../../../../../helpers/date'
import { getInventoryItemId } from '../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/helpers'
import { getDatesWithInventoryOverlap } from '../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/validation/noOverlappingGamTargetingPerInventoryPerDay'
import getInventoryAvailabilityTimelineData from '../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/components/InventoryAvailabilitySpoiler/helpers/getInventoryAvailabilityTimelineData'

import { environmentTypes } from '../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/fields'

export const calculateRemainingDays = ({ right, existingLineItems, inventory }) => {
  const { timelineStartDate } = getInventoryAvailabilityTimelineData(right)

  // Calculate total days from timeline start (today if start is in past) to right end
  const totalDays = getNumberOfDays(timelineStartDate, right.end_date)

  const inventoryIds = inventory.map(item => getInventoryItemId(item))

  // Get dates with conflicts for both video and display environments
  const videoConflictDates = getDatesWithInventoryOverlap({
    existingLineItems,
    proposedInventoryIds: inventoryIds,
    environmentType: environmentTypes.VIDEO_PLAYER
  })

  const displayConflictDates = getDatesWithInventoryOverlap({
    existingLineItems,
    proposedInventoryIds: inventoryIds,
    environmentType: environmentTypes.BROWSER
  })

  // Filter out past dates - only count conflicts from today onwards
  const todayString = new Date().toISOString().split('T')[0]

  const futureVideoConflictDates = videoConflictDates.filter(dateString => dateString >= todayString)
  const futureDisplayConflictDates = displayConflictDates.filter(dateString => dateString >= todayString)

  // Calculate remaining days separately for video and display
  const videoRemainingDays = totalDays - futureVideoConflictDates.length
  const displayRemainingDays = totalDays - futureDisplayConflictDates.length

  return {
    videoRemainingDays,
    displayRemainingDays,
    totalDays
  }
}
